import { isNull } from '../../../../../../utils/chart';

import scss from './tooltipMarkup.module.scss';

const createTooltipMarkup = ({ data, isGlobal }) => {
  if (!data.link) {
    return '';
  }

  const { audienceHeader, audienceSubheader, r1, globalR1, r2, globalR2, total, globalTotal } = data.link;
  const label = audienceHeader + ': ' + audienceSubheader;

  const baseCalculations = [
    {
      label: 'Total',
      value: total + '%',
    },
    {
      label: 'R1',
      value: isNull(r1) ? '-/-' : r1 + '%',
      color: 'var(--resonance-blue)',
    },
    {
      label: 'R2',
      value: isNull(r2) ? '-/-' : r2 + '%',
      color: 'var(--resonance-green)',
    },
  ];

  const globalCalculations = [
    {
      label: 'Global Total',
      value: globalTotal + '%',
    },
    {
      label: 'Global R1',
      value: isNull(globalR1) ? '-/-' : globalR1 + '%',
      color: 'var(--resonance-blue)',
    },
    {
      label: 'Global R2',
      value: isNull(globalR2) ? '-/-' : globalR2 + '%',
      color: 'var(--resonance-green)',
    },
  ];

  return `
    <div class='${scss.outerBox}'>
      <span class='${scss.title}'>
       ${label}
      </span>
      <div class='${scss.infoBlock}'>
        ${(isGlobal ? globalCalculations : baseCalculations).map(createRecord).join('\n')}
      </div>
    </div>
  `;
};

const createRecord = ({ label, value, color }) => {
  return `
    <div class='${scss.record}'>
     ${color ? `<div class="${scss.marker}" style="background-color: ${color}"></div>` : ''}
      <span class='${scss.label}'>${label}:</span>
      <span class='${scss.value}'>${value}</span>
    </div>
  `;
};

export default createTooltipMarkup;
